export default __webpack_public_path__ + "static/media/actividad-28.d2d76fd6.mp3";